import { createBrowserHistory } from 'history'
import { AppStore } from 'src/pc/store/AppStore'
import { GetConfigByChannelHS } from 'src/commons/store/BasisStore'
import { GetChannel } from 'src/commons/utils/index'
import { useWaitModData } from '@hhpack/use-cms'
import axios from 'axios'
import isMobile from 'ismobilejs'

/**
 * 创建路由历史
 */
export const history = createBrowserHistory({
  getUserConfirmation: (message: string, callback: (ok: boolean) => void) => {},
})

/**
 * 用户登录的 token
//  */
export const getPhpToken = () => {
  return localStorage.getItem('php-token') || undefined
}

/** 记录第一次进入的host */
export const recordHost = () => {
  const record = localStorage.getItem('firstUrl')
  !record && localStorage.setItem('firstUrl', window.location.href)
}

/**
 * 添加广告分析
 */
export const httpAdAnalyse = () => {
  const Query = new URLSearchParams(window.location.search)
  Query.delete('token')
  if (Query.toString()) {
    localStorage.setItem('adan', Query.toString())
  }
  axios.defaults.headers.adan = localStorage.getItem('adan') || '' //广告分析头
}

/**
 * 获取当前渠道配置信息
 */
export const loadChannelConfig = async () => {
  try {
    const channel = GetChannel()
    const result = await GetConfigByChannelHS.Execute({ channel: channel || 'www' })
    const globalPaymentConfig = await useWaitModData<{ viewsPaymethod?: string }>('global_paymethod_config')
    const globalViewsPayMethod = globalPaymentConfig?.[0]?.viewsPaymethod || ''
    const globalPayMethods = globalViewsPayMethod.split(',')
    const payMethods = result.payType.split(',')
    AppStore.curPayMethod = globalPayMethods.filter(paymethod => payMethods.includes(paymethod)) as Array<
      'alipay' | 'wechat' | 'qq'
    >
  } catch (error) {}
}

/**
 * 生成搜索条件
 * */
export const GenerateSearch = (kv: { k: string; v: string | undefined }[]) => {
  const query = new URLSearchParams(window.location.search)
  kv.forEach(d => {
    if (d.v) {
      query.set(d.k, d.v)
    } else {
      query.delete(d.k)
    }
  })
  history.push(`${window.location.pathname}?${query.toString()}`)
}
